import updateCart from './update-popup-cart.js';
import updatedPromosList from './update-promo-list';
import { mask, setErrors, blockedTimer } from './helpers';
import { postData, putData, deleteData, fetchData } from './fetch.js';

const NAVIGATION_TYPE_WITH_HISTORY = 2;

window.addEventListener('pageshow', (e) => {
  if (e.persisted || (performance && performance.navigation.type === NAVIGATION_TYPE_WITH_HISTORY)) {
    window.location.reload();
  }
});

window.addEventListener('load', () => {
  const loginButton = document.querySelector('.login-button');
  const loginPopupCloseBtn = document.querySelectorAll(
    '.login-popup .close-button',
  );
  const popupOverlays = document.querySelectorAll('.popup-overlay');
  const inputs = document.querySelectorAll('.input-wrapper .input');
  const mfaInputs = document.querySelectorAll('.login-form .code-select-radio-button');
  const inputWrappers = document.querySelectorAll('.input-wrapper');
  const loginForm = document.querySelector('.login-form');
  const phoneInput = document.getElementById('phone-input');
  const mfaInput = document.getElementById('code-mfa');
  const loginPhoneInputWrapper = document.querySelector(
    '.login-form .phone-input',
  );
  const codeMfaSendTo = document.querySelector('.code-mfa-send-to');
  const codeSelectorWrapper = document.querySelector('.login-form .code-select-wrapper');
  const termsAndPolicy = document.querySelector('.login-form .terms-and-policy');
  const loginSubmit = document.querySelector('.login-form .next-button');
  const codeInputWrapper = document.querySelector('.code-input-wrapper');
  const codeInput = document.querySelector('.code-input input');
  const codeInputContainer = document.querySelector('.code-input');
  const loginText = document.querySelector('.login-text');
  const phoneEditBtn = document.querySelector('.edit-button-wrapper .edit-btn');
  const loginFormWrapper = document.querySelector('.login-wrapper');
  const registrationFormWrapper = document.querySelector(
    '.registration-wrapper',
  );
  const registrationForm = document.querySelector('.registration-form');
  const registrationFormSubmit = document.querySelector('.name-form-submit');
  const nameInput = document.getElementById('name-input');
  const successRegistrationWrapper = document.querySelector(
    '.success-registration-wrapper',
  );
  const userName = document.querySelectorAll(
    '.success-registration-wrapper .name',
  );
  const congratsText = document.querySelector('.congrats-text');
  const cartPopup = document.querySelector('.cart-popup');
  const cartButton = document.querySelector('.cart-button');
  const closePopupBtns = document.querySelectorAll('.close-popup');
  const showPopupBtns = document.querySelectorAll('.show-popup-btn');
  const errorMessage = document.querySelector('.login-popup .error-message');
  const resendCodeValue = document.querySelector(
    '.login-popup .resend-code span',
  );
  const resendCodeForm = document.querySelector(
    '.login-wrapper .resend-code-form ',
  );
  const hiddenPhoneInput = document.querySelector('.hidden-phone-input');
  const phoneErrorsList = document.querySelector('.phone-errors');
  const codeErrorsList = document.querySelector('.code-errors');
  const reloadButton = document.querySelectorAll('.reload-button');
  const profileButton = document.querySelector('.login-popup .profile-btn');
  const mobileMenuButton = document.querySelectorAll('.burger-btn');
  const mobileMenu = document.querySelector('.mobile-menu');
  const nameErrors = document.querySelector('.name-errors');
  const portalMenuLinks = document.querySelectorAll('.portal-menu li a');
  const landingMenuLinks = document.querySelectorAll('.landing-menu li a');
  const headerBottom = document.querySelector('.header-content-bottom');
  const bonusLinksWrapper = document.querySelector('.bonus-links-wrapper');
  const cartPopupWrapper = document.querySelector('.cart-popup-wrapper');
  const cartTitle = document.querySelector('.cart-title');
  const cartItems = document.querySelector('.cart-items');
  const mobileCartItems = document.querySelector('.mobile-cart-items');
  const loginTextWrapper = document.querySelector('.login-text-wrapper');
  const loginTextErrorWrapper = document.querySelector(
    '.login-text-error-wrapper',
  );
  const blockedErrorText = document.querySelector('.blocked-error-text');
  const blockedErrorTimer = document.querySelector('.blocked-error-timer span');
  const mobileCart = document.querySelector('.mobile-cart-button');
  const googleStoreButtons = document.querySelectorAll('.google-store');
  const appStoreButtons = document.querySelectorAll('.app-store');
  const codeMfaError = document.querySelector('.code-mfa-error');
  const ruStoreButtons = document.querySelectorAll('.ru-store');
  const phoneEditBtnWrapper = document.querySelector('.edit-button-wrapper');
  const resendCodeWrapper = document.querySelector('.resend-code-default');
  const codeTextContent = document.querySelector('.code-text-content');

  let mfaTimeout;
  let ttlInterval;

  const getCurrentMenuItem = () => {
    [].forEach.call(landingMenuLinks, (link, index) => {
      var href = link.getAttribute('href');
      link.classList.remove('active');

      if (window.location.hash === href) {
        link.classList.add('active');

        const currentCategoryWrapper = document.getElementById(
          href.replace('#', ''),
        );

        if (currentCategoryWrapper) {
          const offsetTop = currentCategoryWrapper.offsetTop;

          setTimeout(() => {
            window.scrollTo(0, offsetTop);
          }, 150);
        }
      } else if (!window.location.hash) {
        if (index === 0) {
          link.classList.add('active');
        }

        if (index === landingMenuLinks.length / 2) {
          link.classList.add('active');
        }
      }
    });
  };

  getCurrentMenuItem();

  const cookies = document.cookie.split(';');
  let phonesValues = {
    phones: [],
    expires: null,
  };

  const phoneValuesFromLS = localStorage ? localStorage.getItem('phonesValues') : null;

  if (phoneValuesFromLS) {
    phonesValues = JSON.parse(phoneValuesFromLS);

    if (phonesValues.expires <= Date.now()) {
      localStorage.removeItem('phonesValues');
    }
  }

  const blockedCookie = cookies.find((cookie) =>
    cookie.includes('phoneBlocked'),
  );
  const ttlResponseCookie = cookies.find((cookie) =>
    cookie.includes('ttlResponse'),
  );

  if (bonusLinksWrapper) {
    bonusLinksWrapper.removeAttribute('title');
  }

  if (loginButton) {
    loginButton.removeAttribute('title');
  }

  if (portalMenuLinks) {
    [].forEach.call(portalMenuLinks, (link) => {
      const returnLink = link.dataset.return;

      const href = link
        .getAttribute('href')
        .replace(`?returnTo=${returnLink}`, '');
      if (window.location.pathname.includes(href)) {
        link.classList.add('active');
      }
    });
  }

  window.addEventListener('hashchange', () => {
    getCurrentMenuItem();
  });

  let interval;
  let timeout;
  let blockedInterval;

  const blockAuth = (time, text) => {
    if (loginTextWrapper) {
      loginTextWrapper.classList.add('hidden');
    }

    if (loginTextErrorWrapper) {
      loginTextErrorWrapper.classList.add('visible');
    }

    if (blockedErrorText) {
      blockedErrorText.textContent = text;
    }

    if (loginPopupCloseBtn) {
      [].forEach.call(loginPopupCloseBtn, (button) => {
        button.classList.add('blocked');
      });
    }

    let currentTime = time;

    blockedInterval = setInterval(() => {
      currentTime = currentTime - 1;

      const timeString = blockedTimer(currentTime);

      if (blockedErrorTimer) {
        blockedErrorTimer.textContent = timeString;
      }

      if (currentTime === 0) {
        clearInterval(blockedInterval);

        if (loginTextWrapper) {
          loginTextWrapper.classList.remove('hidden');
        }

        if (loginTextErrorWrapper) {
          loginTextErrorWrapper.classList.remove('visible');
        }

        if (blockedErrorText) {
          blockedErrorText.textContent = '';
        }

        if (blockedErrorTimer) {
          blockedErrorTimer.textContent = '';
        }

        if (loginPopupCloseBtn) {
          [].forEach.call(loginPopupCloseBtn, (button) =>
            button.classList.remove('blocked'),
          );
        }

        const phoneValuesFromLS = localStorage ? localStorage.getItem('phonesValues') : null;

        if (phoneValuesFromLS) {
          localStorage.removeItem('phonesValues');
        }

        phonesValues = {
          phones: [],
          expires: null,
        };
      }
    }, 1000);
  };

  if (googleStoreButtons) {
    [].forEach.call(googleStoreButtons, (button) => {
      button.addEventListener('click', () => {
        ym(82678129, 'reachGoal', 'Play Market');

        const { href } = button.dataset;
        window.open(href, '_blank');
      });
    })
  }

  if (appStoreButtons) {
    [].forEach.call(appStoreButtons, (button) => {
      button.addEventListener('click', () => {
        ym(82678129, 'reachGoal', 'App Story');

        const { href } = button.dataset;
        window.open(href, '_blank');
      });
    })
  }
  if (ruStoreButtons) {
    [].forEach.call(ruStoreButtons, (button) => {
      button.addEventListener('click', () => {
        ym(82678129,'reachGoal','Ru Story');

        const { href } = button.dataset;
        window.open(href, '_blank');
      });
    })
  }

  if (loginPopupCloseBtn) {
    [].forEach.call(loginPopupCloseBtn, (button) => {
      button.addEventListener('click', () => {
        if (!button.classList.contains('blocked')) {
          if (phonesValues.phones.length === 3) {
            const time = 120;
            const text =
              'Повторная отправка SMS с кодом с вашего бразуера возможна через';

            blockAuth(time, text);
          }

          if (loginForm) {
            loginForm.reset();
          }

          if (loginFormWrapper) {
            loginFormWrapper.classList.remove('hidden');
          }

          if (termsAndPolicy) { 
            termsAndPolicy.classList.remove('hidden');
          }

          // if (codeSelectorWrapper) {
          //   codeSelectorWrapper.classList.remove('hidden');
          // }

          if (codeMfaSendTo) { 
            codeMfaSendTo.classList.remove('visible');
          }

          if (phoneInput) {
            phoneInput.removeAttribute('disabled');
          }

          if (registrationForm) {
            registrationForm.reset();
            registrationFormWrapper.classList.add('hidden');
          }

          if (successRegistrationWrapper) {
            successRegistrationWrapper.classList.add('hidden');
          }

          if (loginPhoneInputWrapper) {
            loginPhoneInputWrapper.classList.remove('disabled');
          }

          if (loginText) {
            loginText.classList.remove('hidden');
          }

          if (codeInputWrapper) {
            codeInputWrapper.classList.add('hidden');
          }

          if (codeMfaError) { 
            codeMfaError.classList.remove('visible');
          }

          // if (codeTextContent) {
          //   codeTextContent.textContent = 'Перейдите в течении';
          // }

          if (loginSubmit) {
            loginSubmit.classList.remove('hidden');
            loginSubmit.setAttribute('disabled', 'disabled');
            loginSubmit.textContent = 'Далее';
          }

          if (errorMessage) {
            errorMessage.classList.remove('visible');
            errorMessage.textContent = '';
          }

          if (resendCodeWrapper) { 
            resendCodeWrapper.classList.add('hidden');
          }

          if (resendCodeForm) {
            resendCodeForm.classList.add('hidden');
          }
        }

        clearInterval(mfaTimeout);
        clearInterval(ttlInterval);

        if (phoneInput) {
          phoneInput.removeAttribute('disabled');
        }

        if (loginPhoneInputWrapper) {
          loginPhoneInputWrapper.classList.remove('disabled');
        }

        if (codeInputWrapper) {
          codeInputWrapper.classList.add('hidden');
        }

        if (resendCodeForm) {
          resendCodeForm.classList.add('hidden');
        }

        if (resendCodeValue) {
          resendCodeValue.textContent = '';
        }

        clearInterval(interval);
        clearTimeout(timeout);
      });
    });
  }

  if (mfaInputs) {
    [].forEach.call(mfaInputs, (input) => {
      const { value } = input;

      input.addEventListener('change', () => {
        loginForm.dispatchEvent(new Event('submit'));
      });

      input.addEventListener('input', () => {
        if (mfaInput) { 
          mfaInput.setAttribute('value', value);

          if (codeMfaSendTo) { 
            if (value === 'PHONE_CALL') {
              codeMfaSendTo.textContent = 'Для авторизации позвоните на номер 8-800-000-00-00';
            } else { 
              codeMfaSendTo.textContent = 'Для авторизации перейдите в Telegram'
            }
          }

          if (phoneInput) { 
            const { value: phoneValue } = phoneInput;
            const phoneInvalid = /[012567]/g.test(phoneValue.charAt(0));

            if (phoneValue.length === 13 && !phoneInvalid) {
              if (loginSubmit) {
                loginSubmit.removeAttribute('disabled');
              }
            }
          }
        }
      });

    });
  }

  if (inputs) {
    [].forEach.call(inputs, (input, index) => {
      const placeholder = input.getAttribute('placeholder');

      const { value } = input;

      if (value) {
        inputWrappers[index].classList.add('focused');
      }

      input.addEventListener('focus', () => {
        input.setAttribute('placeholder', '');
        inputWrappers[index].classList.add('focused');
      });

      input.addEventListener('blur', (e) => {
        const { value } = e.target;

        if (!value) {
          inputWrappers[index].classList.remove('focused');
          input.setAttribute('placeholder', placeholder);
        }
      });
    });
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', () => {
      mask(phoneInput, '___ ___ __-__', 'login');
    });

    phoneInput.addEventListener('focus', () => {
      mask(phoneInput, '___ ___ __-__', 'login');
    });

    phoneInput.addEventListener('blur', () => {
      mask(phoneInput, '___ ___ __-__', 'login');
    });

    phoneInput.addEventListener('keyup', (e) => {
      const { value } = e.target;
      const phoneInvalid = /[012567]/g.test(value.charAt(0));

      if (phoneInvalid) {
        if (loginPhoneInputWrapper) {
          loginPhoneInputWrapper.classList.add('error');
        }
      } else {
        loginPhoneInputWrapper.classList.remove('error');
      }

      if (value.length === 13 && !phoneInvalid) {
        codeSelectorWrapper.classList.remove('hidden');

        [].forEach.call(mfaInputs, (input) => {
          input.removeAttribute('disabled');
        });
      } else {
        codeSelectorWrapper.classList.add('hidden');

        [].forEach.call(mfaInputs, (input) => {
          input.checked = false;
          input.setAttribute('disabled', 'disabled');
        });
      }
    })
  }

  const getMfaToken = async (token) => { 
    const tokenResponse = await postData('/login/mfa-verified', { mfa: token });
    

    if (tokenResponse && tokenResponse.statusCode !== 400) { 
      setTimeout(() => {
        if (loginFormWrapper) {
          loginFormWrapper.classList.add('hidden');
        }

        if (tokenResponse?.user?.name) {
          if (successRegistrationWrapper) {
            successRegistrationWrapper.classList.remove('hidden');
          }

          if (userName) {
            [].forEach.call(
              userName,
              (item) => (item.textContent = tokenResponse.user?.name),
            );
          }

          if (tokenResponse.user.loyaltyProgramActive) {
            if (congratsText) {
              congratsText.textContent =
                'Теперь Вам доступны бонусы, персональные предложения и подарки от Жар Пицца. В профиле сохраняется история заказов и адресов доставки.';
            }
          } else {
            if (congratsText) {
              congratsText.textContent =
                'Теперь Вам доступны персональные предложения и подарки от Жар Пицца. В профиле сохраняется история заказов и адресов доставки.';
            }
          }
        } else {
          registrationFormWrapper?.classList.remove('hidden');

          if (nameInput) {
            nameInput.focus();
          }
        }

        if (reloadButton) {
          [].forEach.call(reloadButton, (button) => {
            button.dataset.cityname = tokenResponse.transliteratedCityName;
            button.classList.add('visible');
          });
        }

        if (profileButton) {
          profileButton.dataset.cityName =
          tokenResponse.transliteratedCityName;
        }

        if (loginPopupCloseBtn) {
          [].forEach.call(loginPopupCloseBtn, (button) =>
            button.classList.add('hidden'),
          );
        }
      }, 1000);
    }
  }

  if (codeInput) {
    codeInput.addEventListener('keyup', async (e) => {
      codeInput.value = e.target.value.replace(/[^0-9]/g, '');

      const { value } = e.target;

      if (value.length === 4) {
        const body = {
          code: value,
        };

        const response = await postData('/login/mfa/code', body);

        if (response) {
          if (response.statusCode === 400) {
            codeInputContainer.classList.add('error');

            if (response.errors && response.errors.code && codeErrorsList) {
              setErrors(codeErrorsList, response.errors.code);
            }

            if (response.errors && response.errors._global && errorMessage) {
              errorMessage.classList.add('visible');
              setErrors(errorMessage, response.errors._global);
            }
          } else {
            codeInputContainer.classList.remove('error');
            codeInputContainer.classList.add('valid');

            if (codeErrorsList) {
              codeErrorsList.innerHTML = '';
            }

            if (errorMessage) {
              errorMessage.textContent = '';
              errorMessage.classList.remove('visible');
            }

            getMfaToken(response.data.token)
          }
        }
      }
    });
  }

  if (ttlResponseCookie && blockedCookie) {
    const ttlResponse = ttlResponseCookie.split('=');

    const time = Math.round(
      (122000 - (Date.now() - parseFloat(ttlResponse[1]))) / 1000,
    );
    const text =
      'Повторная отправка SMS с кодом на данный номер возможна через';

    blockAuth(time, text);
  }

  if (phonesValues && phonesValues.phones && phonesValues.phones.length === 3) {
    const time = Math.round(
      (parseFloat(phonesValues.expires) - Date.now()) / 1000,
    );
    const text =
      'Повторная отправка SMS с кодом с вашего бразуера возможна через';

    blockAuth(time, text);
  }

  const clearState = () => { 
    if (resendCodeForm) {
      resendCodeForm.classList.add('hidden');
    }

    if (loginText) {
      loginText.classList.remove('hidden');
    }

    if (phoneInput) {
      phoneInput.removeAttribute('disabled');
    }
    
    if (codeInputWrapper) {
      codeInputWrapper.classList.add('hidden');
    }

    if (loginPhoneInputWrapper) {
      loginPhoneInputWrapper.classList.remove('disabled');
    }

    // if (codeSelectorWrapper) {
    //   codeSelectorWrapper.classList.add('hidden');
    // }

    if (codeMfaSendTo) {
      codeMfaSendTo.classList.remove('visible');
    }

    if (termsAndPolicy) {
      termsAndPolicy.classList.remove('hidden');
    }

    if (codeMfaError) { 
      codeMfaError.classList.remove('visible');
    }

    if (loginSubmit) {
      loginSubmit.classList.remove('hidden');
      loginSubmit.removeAttribute('disabled');
      loginSubmit.textContent = 'Далее';
    }

    if (resendCodeWrapper) { 
      resendCodeWrapper.classList.add('hidden');
    }

    if (phoneEditBtnWrapper) { 
      phoneEditBtnWrapper.classList.add('hidden');
    }

    // if (codeTextContent) {
    //   codeTextContent.textContent = 'Перейдите в течении';
    // }

    clearInterval(mfaTimeout);
    clearInterval(ttlInterval);
  }

  if (phoneEditBtn) {
    phoneEditBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (phonesValues.phones.length === 3) {
        const time = 120;
        const text =
          'Повторная отправка SMS с кодом с вашего бразуера возможна через';

        blockAuth(time, text);
      }

      if (resendCodeForm) {
        resendCodeForm.classList.add('hidden');
      }

      if (loginText) {
        loginText.classList.remove('hidden');
      }

      if (phoneInput) {
        phoneInput.removeAttribute('disabled');
        phoneInput.value = '';
        phoneInput.focus();
      }

      if (codeInputWrapper) {
        codeInputWrapper.classList.add('hidden');
      }

      if (loginPhoneInputWrapper) {
        loginPhoneInputWrapper.classList.remove('disabled');
      }

      if (loginSubmit) {
        loginSubmit.classList.remove('hidden');
        loginSubmit.removeAttribute('disabled');
        loginSubmit.textContent = 'Далее';
      }

      clearState();

      clearTimeout(timeout);
      clearInterval(interval);
    });
  }

  const getMfaStatus = async (token) => { 
    const response = await fetchData(`/login/mfa/${token}`);

    if (response.data.status === 'FAILED') {
      clearInterval(mfaTimeout);
      clearInterval(ttlInterval);
      clearState();
    } else if (response.data.status === 'VERIFIED') {
      clearInterval(mfaTimeout);
      clearInterval(ttlInterval);

      getMfaToken(response.data.token)
    }
  }

  const clearStepOne = (expiresAt, token) => {
    if (resendCodeWrapper) {
      resendCodeWrapper.classList.remove('hidden');
    }

    if (loginPhoneInputWrapper) {
      loginPhoneInputWrapper.classList.add('disabled');
    }

    if (phoneEditBtnWrapper) {
      phoneEditBtnWrapper.classList.remove('hidden');
    }

    if (codeSelectorWrapper) {
      codeSelectorWrapper.classList.add('hidden');
    }

    if (termsAndPolicy) {
      termsAndPolicy.classList.add('hidden');
    }

    if (phoneInput) {
      phoneInput.setAttribute('disabled', 'disabled');
    }

    if (loginText) {
      loginText.classList.add('hidden');
    }

    if (loginSubmit) {
      loginSubmit.classList.add('hidden');
    }

    if (document.querySelector('.code-input input')) {
      document.querySelector('.code-input input').focus();
    }

    if (resendCodeForm) {
      resendCodeForm.classList.remove('hidden');
    }

    if (resendCodeValue) {
      resendCodeValue.textContent = Math.round((new Date(expiresAt).getTime()
        - new Date().getTime()) / 1000);
    }

    if (errorMessage) {
      errorMessage.classList.remove('visible');
      errorMessage.textContent = '';
    }

    if (resendCodeValue && resendCodeValue.innerHTML.length) {
      let ttl = parseInt(resendCodeValue.innerHTML, 10);
      let mfaTtl = parseInt(resendCodeValue.innerHTML, 10);

      mfaTimeout = setInterval(() => {
        if (mfaTtl > 0) {
          mfaTtl -= 5;

          getMfaStatus(token);
        }
      }, 5000);


      if (mfaTtl === 0) {
        clearInterval(mfaTimeout);
      }

      const minutes = Math.floor(ttl / 60);
      const seconds = ttl - minutes * 60;

      resendCodeValue.textContent = `${minutes > 9 ? '' : '0'}${minutes}:${seconds > 9 ? '' : '0'}${seconds}`;

      ttlInterval = setInterval(() => {
        if (ttl > 0) {
          ttl--;

          const minutes = Math.floor(ttl / 60);
          const seconds = ttl - minutes * 60;

          resendCodeValue.textContent = `${minutes > 9 ? '' : '0'}${minutes}:${seconds > 9 ? '' : '0'}${seconds}`;
        }
      }, 1000);

      if (ttl === 0) {
        clearInterval(ttlInterval);
      }

      timeout = setTimeout(() => {
        clearState();
      }, (new Date(expiresAt).getTime()
        - new Date().getTime()));
    }
  }


  if (loginForm) {
    loginForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const phone = phoneInput.value
        .replace(' ', '')
        .replace(' ', '')
        .replace('-', '');
      
      const mfa = mfaInput.value;

      if (
        phonesValues.phones.length < 3 &&
        !phonesValues.phones.find((item) => item === phone)
      ) {
        phonesValues.phones.push(phone);
        phonesValues.expires = Date.now() + 60 * 60 * 1000;

        if (localStorage) {
          localStorage.setItem('phonesValues', JSON.stringify(phonesValues));
        }
      }

      if (phonesValues.phones.length === 3) {
        phonesValues.expires = Date.now() + 120 * 1000;

        if (localStorage) {
          localStorage.setItem('phonesValues', JSON.stringify(phonesValues));
        }
      }

      const body = {
        phone,
        mfa,
      };

      if (loginSubmit) {
        loginSubmit.setAttribute('disabled', 'disabled');
        loginSubmit.textContent = 'Загрузка...';
      }

      if (hiddenPhoneInput) {
        hiddenPhoneInput.value = phone;
      }

      const response = await postData('/login399', body);

      if (response) {
        if ([400, 417].includes(response.statusCode)) {
          if (response.errors && response.errors.blocked) {
            const time = response.errors.blocked;
            const text = response.errors._global[0];

            blockAuth(time, text);
          }

          loginSubmit.removeAttribute('disabled');
          loginSubmit.textContent = 'Далее';

          if (response.errors && response.errors.phone && phoneErrorsList) {
            setErrors(phoneErrorsList, response.errors.phone);
          }

          if (
            response.errors &&
            response.statusCode !== 417 &&
            response.errors._global &&
            !response.errors.blocked &&
            errorMessage
          ) {
            errorMessage.classList.add('visible');
            setErrors(errorMessage, response.errors._global);
          }
        } else if (response.statusCode === 403) {
          const body = {
            phone,
            mfa: 'SMS',
          };
    
          const smsResponse = await postData('/login399', body);
    
          if (smsResponse) {
            if (smsResponse.statusCode === 403) { 
              clearState();

              if (loginPhoneInputWrapper) {
                loginPhoneInputWrapper.classList.add('disabled');
              }

              if (loginPhoneInputWrapper) {
                loginPhoneInputWrapper.classList.add('disabled');
              }

              loginSubmit.setAttribute('disabled', 'disabled');
              loginSubmit.textContent = 'Далее';

              if (errorMessage) { 
                errorMessage.classList.add('visible');
                errorMessage.innerHTML = `<li>Вы превысили попытки авторизации, попробуйте позже</li>`;
              }

              if (mfaInputs) { 
                [].forEach.call(mfaInputs, (input) => {
                  input.classList.add('disabled');
                });
              }
            } else if (smsResponse.data && smsResponse.data instanceof Object && !smsResponse.error) {
              clearStepOne(smsResponse.data.expiresAt, smsResponse.data.token);

              if (codeInputWrapper) {
                codeInputWrapper.classList.remove('hidden');
              }
    
              if (codeMfaError) { 
                codeMfaError.classList.add('visible');
              }
    
              if (codeTextContent) { 
                codeTextContent.textContent = 'Код действителен в течение';
              }
    
            } else if (smsResponse.error) {
              clearState();
    
              errorMessage.classList.add('visible');
    
              errorMessage.innerHTML = `<li>${smsResponse.message}</li>`;
            }
          }
        } else if (response.statusCode === 500) {
          loginSubmit.removeAttribute('disabled');
          loginSubmit.textContent = 'Далее';

          if (errorMessage) {
            errorMessage.textContent = '';
            errorMessage.classList.add('visible');

            const li = document.createElement('li');
            li.textContent = response.data;

            errorMessage.append(li);
          }
        } else {
          clearStepOne(response.data.expiresAt, response.data.token);


          if (codeMfaSendTo) {
            codeMfaSendTo.classList.add('visible');
          }

          if (codeMfaSendTo) { 
            if (mfa === 'PHONE_CALL') {
              const phone = response.data.callPhone.slice(-10).replace(/(\d{3})(\d{3})(\d{2})(\d{2})/gi, '+7 ($1) $2-$3-$4');
              codeMfaSendTo.innerHTML = `<span class='pc-mfa-text'><span>Для входа позвоните на номер</span><i>После сброса звонка, подождите несколько секунд.<br/>Звонок бесплатный</i><a href=tel:${response.data.callPhone} target="_blank">${phone}</a></span>`;
              codeTextContent.textContent = 'Позвоните в течении';
            } else {
              codeMfaSendTo.innerHTML = `<span class='tg-mfa-text'><span>Для входа нажмите на кнопку</span><i>Проверьте, что вы авторизованы в Telegram<br/>по этому же номеру телефона</i><a href='https://t.me/${response.data.botName.replace('@', '')}?start=${response.data.token}' target="_blank" rel="noreferrer">Войти через Telegram</a></span>`;
              codeTextContent.textContent = 'Перейдите в течении';
            }
          }
        }
      }
    });
  }

  if (nameInput) {
    nameInput.addEventListener('input', (e) => {
      const { value:initValue } = e.target;
      let value = initValue;

      if (value.match(/\s\s+/g)?.length > 1) {
        value = value.trim();
      }

      value = value.replace(/[^A-ZА-Я\-]/gi, ' ').replace(/\s\s+/g, ' ').substring(0, 24)

      nameInput.value = value;

      if (value.length > 1) {
        if (registrationFormSubmit) {
          registrationFormSubmit.removeAttribute('disabled');
        }
      } else {
        registrationFormSubmit.setAttribute('disabled', 'disabled');
      }
    });

    nameInput.addEventListener("blur", (e) => {
      nameInput.value = nameInput.value.trim();
    })
  }

  if (registrationForm) {
    registrationForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const name = nameInput.value;

      let cityId;

      const cityCookie = cookies.find((cookie) =>
        cookie.includes('cityId'),
      );

      if (cityCookie) {
        const cityIdCookie = cityCookie.split('=');
        cityId = cityIdCookie[1];
      }

      const body = {
        name,
        cityId,
      };

      const response = await putData('/registration', body);

      if (response) {
        if (response.statusCode === 400) {
          if (response.errors && response.errors.name && nameErrors) {
            setErrors(nameErrors, response.errors.name);
          }
        } else {
          registrationFormWrapper.classList.add('hidden');

          if (successRegistrationWrapper) {
            successRegistrationWrapper.classList.remove('hidden');

            if (userName) {
              [].forEach.call(userName, (item) => {
                item.textContent = name;
              });
            }

            if (congratsText) {
              congratsText.textContent =
                'Теперь Вам доступны персональные предложения и подарки от Жар Пицца. В профиле сохраняется история заказов и адресов доставки.';
            }
          }
        }
      }
    });
  }

  let cartInActiveTimeout;

  if (reloadButton) {
    [].forEach.call(reloadButton, (button) => {
      button.addEventListener('click', () => {
        if (
          registrationFormWrapper
          && !registrationFormWrapper.classList.contains('hidden')
          && nameInput
          && !nameInput.value
        ) {
          document.cookie = "tokenV1=; max-age=-1";
        }

        if (button.classList.contains('with-redirect')) {
          const cityName = button.dataset.cityname;
          window.location.href = cityName;
        } else {
          window.location.reload();
        }
      });
    });
  }

  if (profileButton) {
    profileButton.addEventListener('click', () => {
      if (
        registrationFormWrapper
        && !registrationFormWrapper.classList.contains('hidden')
        && nameInput
        && !nameInput.value
      ) {
        document.cookie = "tokenV1=; max-age=-1";
      }

      if (profileButton.classList.contains('with-redirect')) {
        const cityName = profileButton.dataset.cityname;
        window.location.href = cityName;
      } else {
        window.location.reload();
      }
    });
  }

  if (cartButton) {
    cartButton.addEventListener('mouseenter', () => {
      clearTimeout(cartInActiveTimeout);

      const parentElement = cartButton.closest('.header-content-bottom');
      const cart = parentElement.querySelector('.cart-popup');

      if (cart) {
        cart.classList.add('active');
      }
    });

    cartButton.addEventListener('mouseleave', () => {
      const parentElement = cartButton.closest('.header-content-bottom');
      const cart = parentElement.querySelector('.cart-popup');

      if (cart) {
        cartInActiveTimeout = setTimeout(() => {
          cart.classList.remove('active');
        }, 1500);
      }
    });

    cartButton.addEventListener('click', () => {
      let menuType = 'portal';

      if (cartButton.classList.contains('landing-cart')) {
        menuType = 'delivery';
      }

      document.cookie = `menuType=${menuType}; path=/;`;
    });
  }

  if (mobileCart) {
    mobileCart.addEventListener('click', () => {
      let menuType = 'portal';

      if (mobileCart.classList.contains('landing-cart')) {
        menuType = 'delivery';
      }

      document.cookie = `menuType=${menuType}; path=/;`;
    });
  }

  if (cartPopup) {
    cartPopup.addEventListener('mouseenter', () => {
      clearTimeout(cartInActiveTimeout);
    });

    cartPopup.addEventListener('mouseleave', () => {
      setTimeout(() => {
        cartPopup.classList.remove('active');
      }, 1500);
    });
  }

  if (closePopupBtns) {
    [].forEach.call(closePopupBtns, (btn) => {
      btn.addEventListener('click', () => {
        const parentElement = btn.closest('.popup');

        if (parentElement) {
          parentElement.classList.remove('active');
          document.body.style.overflow = 'auto';
        }
      });
    });
  }

  if (popupOverlays) {
    [].forEach.call(popupOverlays, (overlay) => {
      overlay.addEventListener('click', () => {
        const parentElement = overlay.closest('.popup');

        if (parentElement) {
          parentElement.classList.remove('active');
          document.body.style.overflow = 'auto';
          
          const url = new URL(window.location.href);
          url.searchParams.delete('show-popup');
          history.pushState(null, document.title, url);
        }
      });
    });
  }

  if (showPopupBtns) {
    [].forEach.call(showPopupBtns, (btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const { id } = btn.dataset;

        if (document.getElementById(id)) {
          document.body.style.overflow = 'hidden';
          document.getElementById(id).classList.add('active');
        }
      });
    });
  }

  if (window.location.search.split("=")[0] === "?show-popup") {
    const popupId = window.location.search.split("=")[1]
    const popupButton = document.querySelector(`[data-id="${popupId}"]`)

    if (popupButton) {
      popupButton.click()
    }
  }

  if (mobileMenuButton) {
    [].forEach.call(mobileMenuButton, (button) => {
      button.addEventListener('click', () => {
        document.body.classList.toggle('overflow');

        if (mobileMenu) {
          mobileMenu.classList.toggle('visible');
        }
      });
    });
  }

  if (window.innerWidth > 990) {
    const { scrollY } = window;

    if (headerBottom) {
      if (scrollY >= 140) {
        headerBottom.classList.add('fixed');
      }
    }

    window.addEventListener('scroll', () => {
      const scroll = window.scrollY;

      if (window.innerWidth > 990) {
        if (headerBottom) {
          if (scroll >= 140) {
            headerBottom.classList.add('fixed');
          } else {
            headerBottom.classList.remove('fixed');
          }
        }
      }
    });
  }

  let resizeTimeout;

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (window.innerWidth >= 990) {
        if (window.scrollY > 0) {
          headerBottom.classList.add('fixed');
        } else {
          headerBottom.classList.remove('fixed');
        }
      }
    }, 30);
  });

  let quantityTimeout;

  const updateQunatity = async (body, productId) => {
    const response = await putData('/cart', body);

    if (response) {
      if (response.statusCode === 200) {
        updateCart(response.data, response.data.additional);
        updatedPromosList(response.data.promos);

        let parentElement = document.querySelector(
          `.buy-wrapper[data-id="${productId}"]`,
        );

        const productPopUpParentElement = document.querySelector(
          `.product-popup .buy-wrapper[data-id="${productId}"]`,
        );

        if (!parentElement) {
          parentElement = document.querySelector(
            `.product-card[data-id="${productId}"]`,
          );
        }

        if (parentElement) {
          const productCountInput = parentElement.querySelector(
            '.count-input',
          );
          const buttonMinus = parentElement.querySelector('.minus');

          if (productCountInput) {
            productCountInput.value = body.quantity;
          }

          if (buttonMinus && parseInt(body.quantity, 10) === 1) {
            buttonMinus.classList.add('disabled');
          } else {
            buttonMinus.classList.remove('disabled');
          }
        }

        if (productPopUpParentElement) {
          const notAvailableWrapper = productPopUpParentElement.querySelector(
            '.not-available',
          );
          const availableWrapper = productPopUpParentElement.querySelector(
            '.available',
          );
          const countInput = productPopUpParentElement.querySelector(
            '.count-input',
          );

          const currentProduct = response.data.cartItems.find(
            (item) => item.productId === productId,
          );

          if (currentProduct) {
            countInput.dataset.quantity = currentProduct.quantity;

            if (currentProduct.quantity === 99) {
              notAvailableWrapper.classList.add('visible');
              availableWrapper.classList.add('hidden');
            } else {
              if (notAvailableWrapper.classList.contains('visible')) {
                notAvailableWrapper.classList.remove('visible');
              }

              if (availableWrapper.classList.contains('hidden')) {
                availableWrapper.classList.remove('hidden');
              }
            }
          }
        }
      }
    }
  };

  const removeCart = async () => {
    const response = await deleteData('/cart/remove', null);

    if (response && response === 200) {
      const formValuesFromSessionStorage = sessionStorage ? sessionStorage.getItem('formValues') : null;

      if (formValuesFromSessionStorage) {
        sessionStorage.removeItem('formValues');
      }

      if (cartButton) {
        cartButton.innerHTML =
          'Корзина <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.44275 1.25159C2.33619 1.25135 2.23347 1.26391 2.13585 1.2878C2.00204 0.980584 1.82529 0.704964 1.62426 0.495558C1.28306 0.140138 0.744931 0 0 0V1.25C0.455069 1.25 0.716939 1.3182 0.775736 1.37944C1.00252 1.61567 1.2 2.09566 1.2 2.5L1.20603 2.58839L1.79395 6.87532C0.810213 6.92848 0.0481186 7.72426 0.000737148 8.71903L0 9.375C0.0580927 10.4025 0.817652 11.1928 1.76594 11.249L1.90215 11.2492C2.14904 11.9779 2.81598 12.5 3.6 12.5C4.38373 12.5 5.05047 11.9782 5.29757 11.25H6.70242C6.94952 11.9782 7.61627 12.5 8.4 12.5C9.39411 12.5 10.2 11.6605 10.2 10.625C10.2 9.58946 9.39411 8.75 8.4 8.75C7.61627 8.75 6.94952 9.27175 6.70242 10H5.29757C5.05047 9.27175 4.38373 8.75 3.6 8.75C2.81627 8.75 2.14952 9.27175 1.90242 10H1.8C1.494 9.98087 1.21952 9.69525 1.19892 9.33757L1.2 8.75C1.21618 8.42582 1.48879 8.14185 1.82973 8.12423L3.01421 8.12454L3.0228 8.125H9.07011L9.15867 8.09573C9.6136 7.94535 9.97778 7.58851 10.1502 7.12658L10.4188 6.57242C10.6313 6.1337 10.8437 5.69422 11.0508 5.26487C11.5579 4.21317 11.8769 3.54479 11.9475 3.38066C12.3102 2.53778 11.5754 1.88904 10.8244 1.87522L2.44275 1.25159ZM8.86165 6.875H3.06772C3.0292 6.86384 2.99984 6.82985 2.99409 6.78751L2.40615 2.50046L10.736 3.12183C10.5903 3.43145 10.3253 3.98447 9.97846 4.7038L9.96977 4.72183C9.77177 5.13241 9.55959 5.57128 9.3474 6.00942L9.06453 6.59302L9.03526 6.66389C9.00393 6.75485 8.94169 6.82959 8.86165 6.875ZM8.4 11.25C8.73137 11.25 9 10.9702 9 10.625C9 10.2798 8.73137 10 8.4 10C8.06863 10 7.8 10.2798 7.8 10.625C7.8 10.9702 8.06863 11.25 8.4 11.25ZM4.2 10.625C4.2 10.9702 3.93137 11.25 3.6 11.25C3.26863 11.25 3 10.9702 3 10.625C3 10.2798 3.26863 10 3.6 10C3.93137 10 4.2 10.2798 4.2 10.625Z" fill="white"/></svg>';
      }

      if (mobileCartItems) {
        mobileCartItems.innerHTML = '';
      }

      if (cartTitle) {
        cartTitle.innerHTML = '<strong>Корзина</strong>';
      }

      if (cartItems) {
        const { free } = cartItems.dataset;
        const emptyImage = cartItems.dataset.empty;

        cartItems.innerHTML = `<img src="${emptyImage}" class="empty-cart-image" alt="Корзина пуста" />
        <div class="empty-cart-text italic base-text">
          Добавьте товар в корзину
          <span>Бесплатная доставка от ${free} ₽</span>
        </div>`;
      }
    }
  };

  if (cartPopupWrapper) {
    cartPopupWrapper.addEventListener('click', async (e) => {
      const parentElement = e.target.closest('.popup-cart-item');

      if (parentElement) {
        const countInput = parentElement.querySelector('.count-input');
        const buttonMinus = parentElement.querySelector('.minus');
        const buttonPlus = parentElement.querySelector('.plus');
        const id = parentElement.getAttribute('id');
        const productId = parentElement.dataset.id;
        const productType = parentElement.dataset.type;

        const body = {
          productId: id,
        };

        if (e.target.classList.contains('plus')) {
          let count = parseInt(countInput.value, 10);

          clearTimeout(quantityTimeout);

          if (count <= 99) {
            count += 1;
            countInput.value = count;
            body.quantity = countInput.value;

            if (count > 1) {
              buttonMinus.classList.remove('disabled');
            }

            if (count === 99) {
              buttonPlus.classList.add('disabled');
            }

            quantityTimeout = setTimeout(() => {
              updateQunatity(body, productId);
            }, 300);
          }
        }

        if (e.target.classList.contains('minus')) {
          let count = parseInt(countInput.value, 10);

          clearTimeout(quantityTimeout);

          if (count > 1) {
            count -= 1;
            countInput.value = count;
            body.quantity = countInput.value;

            quantityTimeout = setTimeout(() => {
              updateQunatity(body, productId);
            }, 300);
          }

          if (count === 1) {
            buttonMinus.classList.add('disabled');
          }

          if (count < 99 && buttonPlus.classList.contains('disabled')) {
            buttonPlus.classList.remove('disabled');
          }
        }

        if (e.target.classList.contains('delete-button')) {
          const response = await deleteData('/cart', body);

          if (response) {
            if (response.statusCode === 200) {
              let parentElement = document.querySelector(
                `.buy-wrapper[data-id="${productId}"]`,
              );
              const productPopUpParentElement = document.querySelector(
                `.product-popup .buy-wrapper[data-id="${productId}"]`,
              );

              if (!parentElement) {
                parentElement = document.querySelector(
                  `.product-card[data-id="${productId}"]`,
                );
              }

              if (parentElement) {
                const buyButton = parentElement.querySelector(
                  '.buy-button',
                );
                const countButton = parentElement.querySelector(
                  '.count-button',
                );

                if (countButton) {
                  countButton.classList.remove('visible');
                  const countInput = countButton.querySelector(
                    '.count-input',
                  );
                  const buttonMinus = countButton.querySelector('.minus');

                  if (countInput) {
                    countInput.value = 1;
                  }

                  if (buttonMinus) {
                    buttonMinus.classList.add('disabled');
                  }
                }

                if (buyButton) {
                  buyButton.classList.remove('hidden');

                  if (productType === 'drinks') {
                    buyButton.innerHTML = `${buyButton.dataset.price} ₽`;
                  } else if (productType === 'set') {
                    buyButton.innerHTML = `Собрать за ${buyButton.dataset.price} ₽`;
                  } else {
                    buyButton.innerHTML = `В корзину за <span>${buyButton.dataset.price}</span> ₽`;
                  }
                }
              }

              if (productPopUpParentElement) {
                const notAvailableWrapper = productPopUpParentElement.querySelector(
                  '.not-available',
                );
                const availableWrapper = productPopUpParentElement.querySelector(
                  '.available',
                );
                const countInput = productPopUpParentElement.querySelector(
                  '.count-input',
                );

                if (countInput) {
                  countInput.dataset.quantity = 1;
                }

                if (notAvailableWrapper.classList.contains('visible')) {
                  notAvailableWrapper.classList.remove('visible');
                }

                if (availableWrapper.classList.contains('hidden')) {
                  availableWrapper.classList.remove('hidden');
                }
              }

              updatedPromosList(response.data.promos);

              if (response.data.cartItems.length) {
                updateCart(response.data, response.data.additional);
              } else {
                removeCart();

                if (mobileCartItems) {
                  mobileCartItems.classList.remove('visible');
                }
              }
            }
          }
        }
      }
    });
  }
});
